import { enhancedApi } from '@store/generated/communications';

/**
 * Feature-specific tag types for sent documents
 */
const SENT_DOCUMENTS_TAG_TYPES = ['SentDocument', 'SentDocumentList'] as const;

/**
 * Sent Documents API - extends the generated API with custom tagging
 */
export const sentDocumentsApi = enhancedApi
  .enhanceEndpoints({
    addTagTypes: SENT_DOCUMENTS_TAG_TYPES,
    endpoints: {
      getV2ProviderCommunications: {
        providesTags: result =>
          result
            ? [
                ...result.items.map(item => ({
                  type: 'SentDocument' as const,
                  id: item.dispatch_id ?? item.channels[0]?.touchpoint_id,
                })),
                { type: 'SentDocumentList' as const, id: 'LIST' },
              ]
            : [{ type: 'SentDocumentList', id: 'LIST' }],
      },
    },
  });

// Export hooks with user-friendly names
export const {
  useGetV2ProviderCommunicationsQuery: useGetSentDocumentsQuery,
  useLazyGetV2ProviderCommunicationsQuery: useLazyGetSentDocumentsQuery,
} = sentDocumentsApi;
